import { LEADERBOARD_SIZE, MAX_PLAYER_NAME_LENGTH, type ScoreEntry } from '@photo-merge/shared';
import { Button } from '../components/Button';
import styles from './Leaderboard.module.css';

interface LeaderboardProps {
  scores: ScoreEntry[] | null;
  /** Highlights the row this player just added. */
  mine?: ScoreEntry | null;
  limit?: number;
}

export function Leaderboard({ scores, mine, limit = LEADERBOARD_SIZE }: LeaderboardProps) {
  if (scores === null) return <p className={styles.empty}>Loading…</p>;
  if (scores.length === 0) return <p className={styles.empty}>No scores yet — be the first.</p>;

  return (
    <ol className={styles.list}>
      {scores.slice(0, limit).map((entry, i) => {
        const isMine = mine != null && entry.score === mine.score && entry.name === mine.name;
        return (
          <li
            key={`${entry.name}-${entry.score}-${entry.at}-${i}`}
            className={[styles.row, isMine ? styles.mine : ''].filter(Boolean).join(' ')}
          >
            <span className={styles.rank}>{i + 1}</span>
            <span className={styles.name}>{entry.name}</span>
            <span className={styles.points}>{entry.score.toLocaleString()}</span>
          </li>
        );
      })}
    </ol>
  );
}

interface ScoreSubmitProps {
  name: string;
  onNameChange: (name: string) => void;
  onSubmit: () => void;
  submitting: boolean;
  error?: string;
}

export function ScoreSubmit({
  name,
  onNameChange,
  onSubmit,
  submitting,
  error,
}: ScoreSubmitProps) {
  return (
    <form
      className={styles.form}
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <input
        className={styles.input}
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        placeholder="Your name"
        maxLength={MAX_PLAYER_NAME_LENGTH}
        aria-label="Your name"
        enterKeyHint="send"
      />
      <Button type="submit" disabled={submitting}>
        {submitting ? 'Saving…' : 'Add score'}
      </Button>
      {error ? <p className={styles.empty}>{error}</p> : null}
    </form>
  );
}
